import React from 'react'
import PropTypes from 'prop-types'
import { Row, Button, Table } from 'reactstrap'
import Header from './Header'
import TableRow from './Row'
import Filters from './Filters'

AutoTableLayout.propTypes = {
  columns: PropTypes.array.isRequired,
  enableFilter: PropTypes.bool.isRequired,
  export: PropTypes.bool.isRequired,
  exportToCsv: PropTypes.func.isRequired,
  filterData: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  onToggleSort: PropTypes.func.isRequired,
  resolveCellValue: PropTypes.func.isRequired,
  resolveClassName: PropTypes.func.isRequired,
  rowClassName: PropTypes.string,
  rowOnClick: PropTypes.func,
  sort: PropTypes.bool.isRequired,
  sortData: PropTypes.object.isRequired,
  sortedRows: PropTypes.array.isRequired,
  styles: PropTypes.object.isRequired,
  theadClassName: PropTypes.string.isRequired,
  title: PropTypes.string,
  updateFilter: PropTypes.func.isRequired,
}

export default function AutoTableLayout(props) {
  return (
    <div style={{ width: '100%' }}>
      {(props.export || props.title) && (
        <Row className="d-flex m-2">
          {props.title && (
            <h3 className="d-flex align-items-center mr-auto mb-0">
              {props.title}
            </h3>
          )}
          {props.export && (
            <Button
              className="ml-auto"
              color="secondary"
              onClick={props.exportToCsv}
              outline
            >
              <i className="fas fa-file-excel" />
              &nbsp;Export to CSV
            </Button>
          )}
        </Row>
      )}
      <Table {...props.styles}>
        <thead className={props.theadClassName}>
          <Header
            columns={props.columns}
            id={props.id}
            onToggleSort={props.onToggleSort}
            resolveClassName={props.resolveClassName}
            sort={props.sort && props.sortedRows.length > 1}
            sortData={props.sortData}
          />
          {props.enableFilter && (
            <Filters
              columns={props.columns}
              filter={props.filterData}
              id={props.id}
              resolveClassName={props.resolveClassName}
              updateFilter={props.updateFilter}
            />
          )}
        </thead>
        <tbody>
          {props.sortedRows.map((row, rowIndex) => (
            <TableRow
              columns={props.columns}
              id={props.id}
              key={rowIndex}
              resolveCellValue={props.resolveCellValue}
              resolveClassName={props.resolveClassName}
              rowClassName={props.rowClassName}
              rowData={row}
              rowIndex={rowIndex}
              rowOnClick={props.rowOnClick}
            />
          ))}
        </tbody>
      </Table>
      <style>
        {`
          .table {
            margin-bottom: 0;
          }
        `}
      </style>
    </div>
  )
}
